<template>
  <div id="app">
    <components :is="layout">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath" />
      </transition>
    </components>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import DefaultButton from "@/components/ButtonDefault.vue";
// import { dbFs } from "./modules/database";
const default_layout = "blank";
export default {
  components: {
    DefaultButton
  },
  data: () => ({
    users: null
  }),
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
    // ...mapGetters({
    //   user: "getUser"
    // })
  },
  mounted() {
    // this.firebaseReading();
  },
  methods: {
    // firebaseReading() {
    //   this.$bind("users", dbFs.collection("users").doc(this.user?.uid));
    // }
  },
  watch: {
    // users() {
    //   if (!this.users?.status) {
    //     this.$root.toast(
    //       "Sorry! You are not authorized to access this page. Please contact Administrator."
    //     );
    //     this.$root.logout();
    //   }
    // },
    // user() {
    //   if (!this.user?.status) {
    //     this.firebaseReading();
    //   }
    // }
  }
};
</script>
<style>
/* .form-control::placeholder {
  color: #f0dd91 !important;
} */
/* a7e0e4 */
:root {
  --primary-color: #000000;
  --secondary-color: #808080;
  --accent: #557F70;
  --grey: #bababa;
  --grey-lite: #d6d6d6;
  --grey-lite2: #e8e8e8;
  --grey-dark: #8c8c8c;
  --white: #ffffff;
  --half-white: #f7f7f7;
  --shadow: 0 0 10px #ccc;
}
</style>
